import { MenuItem } from './shared/menu/menu.model';

export const MENU: MenuItem[] = [
    {
        label: 'Dashboard',
        icon: 'home',
        link: '/'
    },
    {
        label: 'Titles',
        icon: 'film',
        subItems: [
            {
                label: 'All',
                link: '/titles'
            },
            {
                label: 'Recommendations',
                link: '/titles/recommendations'
            },
            {
                label: 'Jimmy boost',
                link: '/titles/jimmy-boost'
            },
            {
                label: 'Moods',
                link: '/titles/moods'
            }
        ]
    },
    {
        label: 'Streaming',
        icon: 'tv',
        subItems: [
            {
                label: 'Overview',
                link: '/streaming/overview'
            },
            {
                label: 'Overview 2 (sections)',
                link: '/streaming/overview-2'
            },
            {
                label: 'Services',
                link: '/watch-now-services'
            },
            {
                label: 'Scrape Sessions',
                link: '/streaming/scrape-sessions'
            }
        ]
    },
    {
        label: 'Trailers',
        icon: 'video',
        link: '/videos'
    },
    {
        label: 'Carousels',
        icon: 'image',
        link: '/carousels'
    },
    {
        label: 'Theaters',
        icon: 'map-pin',
        subItems: [
            {
                label: 'Theaters',
                link: '/theaters'
            },
            {
                label: 'Cities',
                link: '/cities'
            }
        ]
    },
    {
        label: 'Analytics',
        icon: 'globe',
        link: '/analytics'
    },
    {
        label: 'Search',
        icon: 'search',
        subItems: [
            {
                label: 'Search queries',
                link: '/search/queries'
            },
            {
                label: 'AI searches',
                link: '/search/ai-searches'
            }
        ]
    },
    {
        label: 'Notifications',
        icon: 'bell',
        subItems: [
            {
                label: 'Log',
                link: '/notifications/log'
            }
        ]
    },
    {
        label: 'Rate limiter',
        icon: 'shield',
        link: '/rate-limiter'
    },
    {
        label: 'Reports',
        icon: 'flag',
        link: '/reports'
    },
    {
        label: 'Site updates',
        icon: 'rss',
        link: '/site-updates'
    },
    {
        label: 'Cinebot',
        icon: 'cpu',
        subItems: [
            {
                label: 'Queue',
                link: '/cinebot/queue2'
            },
            {
                label: 'Links',
                link: '/cinebot/links',
            },
            {
                label: 'Patterns',
                link: '/cinebot/patterns',
            }
        ]
    },

    {
        label: 'Users',
        icon: 'users',
        link: '/users',
        acl: 'users',
    },


    {
        label: 'Checkins',
        icon: 'check-square',
        link: '/checkins/list',
        acl: 'users',
    },

    {
        label: 'Mailer',
        icon: 'mail',
        subItems: [
            {
                label: 'Mailing list',
                link: '/mailer/list'
            },
            {
                label: 'Composer',
                link: '/mailer/composer',
            },
            {
                label: 'Push',
                link: '/mailer/push',
            }
        ]
    },

    {
        label: 'Cast & crew',
        icon: 'user-check',
        link: '/cast'
    },

    {
        label: 'Filmweb',
        icon: 'link-2',
        link: '/filmweb'
    },

    {
        label: 'Settings',
        icon: 'settings',
        link: '/settings'
    }

];
